import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { getQaSelector } from '../../../../utils/common'
import { stopPropagation } from '../../../../utils/events'
import { IconSpinnerOverlay, IconWithTooltip } from '../../../Icon'
import { TableCellBase } from '../TableCellBase'

import {
  QA_NAME_VISIBILITY_CONTEXT,
  QA_NAME_VISIBILITY_INVISIBLE,
  QA_NAME_VISIBILITY_VISIBLE,
} from './TableVisibilityCell.constants'
import { getVisibilityIcon } from './TableVisibilityCell.utils'

import * as styles from './TableVisibilityCell.module.css'

function TableVisibilityCell({
  className = styles.TableVisibilityCell,
  disabled,
  getButtonTooltip,
  getPayloadData,
  isLoading,
  isVisible,
  onChange,
  ...restProps
}) {
  const { t } = useTranslation()

  function handleClick(event) {
    stopPropagation(event)

    onChange?.(getPayloadData(isVisible))
  }

  const iconQaProps = getQaSelector({
    context: QA_NAME_VISIBILITY_CONTEXT,
    value: isVisible
      ? QA_NAME_VISIBILITY_VISIBLE
      : QA_NAME_VISIBILITY_INVISIBLE,
  })

  return (
    <TableCellBase {...restProps} className={className}>
      {isLoading ? (
        <IconSpinnerOverlay />
      ) : (
        <IconWithTooltip
          {...iconQaProps}
          Icon={getVisibilityIcon(isVisible)}
          className={classNames(styles.iconContainer, {
            [styles.clickable]: !disabled,
          })}
          tooltip={t(getButtonTooltip(isVisible))}
          onClick={disabled ? undefined : handleClick}
        />
      )}
    </TableCellBase>
  )
}

export default TableVisibilityCell
